<template>
  <div class="z-card pb-0 border-0">
    <h4 class="z-card__title">
      {{ $t('monitoring.employees.title') }}
    </h4>

    <div class="z-card__body mw-80" style="position: relative">
      <div class="circle-row circle-evenly">
        <div class="circle-row__item circle-row__item--green">
          <span>{{ $t('monitoring.call.status.active') }}</span>
          <span>{{ total.not_active | format }}</span>
        </div>

        <div class="circle-row__item circle-row__item--blue">
          <span>{{ $t('monitoring.call.status.busy') }}</span>
          <span>{{ total.active | format }}</span>
        </div>

        <div class="circle-row__item circle-row__item--yellow">
          <span>{{ $t('monitoring.call.status.task') }}</span>
          <span>{{ total.call | format }}</span>
        </div>

        <div class="circle-row__item circle-row__item--red">
          <span>{{ $t('monitoring.call.status.not_active') }}</span>
          <span>{{ total.task | format }}</span>
        </div>

        <template v-if="total.total">
          <stat-total-circle :data="circle_total" :colors="circle_colors">
            <span slot="title">{{ $t('monitoring.field.total') }}</span>
            <span slot="amount">{{ total.total | format }}</span>
          </stat-total-circle>
        </template>
        <template v-else>
          <div class="circle-row__item circle-row__item--grey">
            <span>{{ $t('monitoring.field.total') }}</span>
            <span>{{ total.total | format }}</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { green, blue, yellow, red } from '@shared/helpers/css';
  import StatTotalCircle from '@shared/components/stats-chart-cicle-total';
  import { DATA } from '@/plugins/vuex-async-pagginate';

  export default {
    components: {
      StatTotalCircle
    },

    filters: {
      format: function (val) {
        return parseInt(val).toLocaleString();
      }
    },

    computed: {
      ...mapGetters('monitoring/employees/table', { items: DATA }),
      chart_options() {
        return {
          series: {
            0: { color: green },
            1: { color: blue },
            2: { color: yellow },
            3: { color: red }
          }
        };
      },
      columns() {
        return [
          '',
          this.$t('voice.call.status.answered'),
          this.$t('voice.call.status.busy'),
          this.$t('voice.call.status.no_answer'),
          this.$t('voice.call.status.failed')
        ];
      },

      chart_data() {
        const values = this.items.map((i) => [i['not_active'], i['active'], i['call'], i['task']]);

        return [this.columns, ...values];
      },

      total: function () {
        return {
          not_active: this.items.filter((i) => i.status == 'not_active').length,
          active: this.items.filter((i) => i.status == 'active').length,
          call: this.items.filter((i) => i.status == 'call').length,
          task: this.items.filter((i) => i.status == 'task').length,
          total: this.items.map((i) => i.status).length
        };
      },

      circle_total: function () {
        return [
          ['', ''],
          ['', this.total.not_active],
          ['', this.total.active],
          ['', this.total.call],
          ['', this.total.task]
        ];
      },

      circle_colors: function () {
        return [green, blue, yellow, red];
      }
    }
  };
</script>

<style lang="scss">
  .circle-evenly {
    justify-content: space-evenly;
  }
</style>
